export const ICONS = {
	EYECON: "/icon-select.webp",
	ARROW_LEFT: "/icon-ux-nav-arrow-left.webp",
	ARROW_RIGHT: "/icon-ux-nav-arrow-right.webp",
	ARROW: "/icon-ux-nav-arrow.webp",
	HOME: {
		DEFAULT: "/icon-home-default.webp",
		HOVER: "/icon-home-hover.webp",
	},
	BACK: {
		DEFAULT: "/icon-back-default.webp",
		HOVER: "/icon-back-hover.webp",
	},
	RADIO: {
		POWER: "/icon-radio-power.webp",
		STATION: "/icon-radio-playlist.webp",
	},
} as const;
